// Recall's Bot API only accepts these hosts as meeting_url (meeting-agent's
// SUPPORTED_MEETING_URL_HOSTS) - keep this map in sync with that list so "supported platform"
// here means the same thing as "MeetingAgent can actually join this meeting".
const MEETING_PLATFORM_NAMES_BY_HOST: Record<string, string> = {
  'zoom.us': 'Zoom',
  'meet.google.com': 'Google Meet',
  'teams.microsoft.com': 'Microsoft Teams',
  'teams.live.com': 'Microsoft Teams',
  'webex.com': 'Webex',
  'gotomeeting.com': 'GoToMeeting',
};

export const SUPPORTED_MEETING_URL_HOSTS = Object.keys(MEETING_PLATFORM_NAMES_BY_HOST);

/** Returns the recognized meeting platform's display name for a URL, or null if it's unparseable or unsupported. */
export function getMeetingPlatform(url: string | null | undefined): string | null {
  if (!url) return null;

  let hostname: string;
  try {
    hostname = new URL(url).hostname;
  } catch {
    return null;
  }

  const host = SUPPORTED_MEETING_URL_HOSTS.find(
    candidate => hostname === candidate || hostname.endsWith(`.${candidate}`)
  );
  return host ? MEETING_PLATFORM_NAMES_BY_HOST[host] : null;
}
